import { AnimatePresence, motion } from "framer-motion"

interface BracketHoldingsStatsProps {
  isExpanded: boolean
  shares?: number | undefined
  maxWinAmount?: number | undefined
  position?: number | undefined
  averagePrice?: number | undefined
}

// Example positions for testing
const examplePositions = [
  {
    position: 1,
    shares: 150,
    averagePrice: 45.75,
    maxWinAmount: 6750,
  },
  {
    position: 2,
    shares: 75,
    averagePrice: 52.3,
    maxWinAmount: 3922.5,
  },
  {
    position: 3,
    shares: 200,
    averagePrice: 38.9,
    maxWinAmount: 7780,
  },
]

export function BracketHoldingsStats({
  isExpanded,
  shares,
  maxWinAmount,
  position: _position = examplePositions[0]?.position,
  averagePrice: _averagePrice = examplePositions[0]?.averagePrice,
}: BracketHoldingsStatsProps) {
  const formatAmount = (value: number | undefined): string => {
    if (value === undefined) return "0"
    if (value < 1000) {
      return Number(value.toFixed(2)).toString()
    }

    if (value < 1000000) {
      const inK = value / 1000
      return `${Number(inK.toFixed(2))}K`
    }

    if (value < 1000000000) {
      const inM = value / 1000000
      return `${Number(inM.toFixed(2))}M`
    }

    const inB = value / 1000000000
    return `${Number(inB.toFixed(2))}B`
  }

  // Don't render if user has no holdings
  if (!shares || shares <= 0) {
    return null
  }

  return (
    <AnimatePresence>
      {isExpanded && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.2 }}
          className="overflow-hidden"
        >
          <div className="mx-0 mt-2 mb-2 px-2 py-3 w-full bg-white/3 rounded-[8px] border border-white/5">
            <div className="flex flex-col space-y-2">
              <div className="flex items-center justify-center">
                <div className="flex items-center">
                  <span className="text-white text-sm ml-1">{formatAmount(shares)} shares</span>
                  <span className="text-white/70 text-sm ml-1"> held to win </span>
                  <span className="text-[#22FF65] text-sm ml-1">+{formatAmount(maxWinAmount)} </span>
                  <span className="text-white/70 text-sm ml-1">BRACKY</span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
